/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import AdditionalFields from './AdditionalFields/index'
import DependsOn from './DependsOn/index'
import Id from './Id/index'
import OriginalPrompt from './OriginalPrompt/index'
import Prompt from './Prompt/index'
import React from 'react'
import Required from './Required/index'
import SubPrompt from './SubPrompt/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Leads/Content/Content/Questions/Content/Editor/Content/EditArea/QuestionFields/Content"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<OriginalPrompt
  viewPath={`${viewPath}/OriginalPrompt`}
/>
</div>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<Prompt
  viewPath={`${viewPath}/Prompt`}
/>
<Required
  viewPath={`${viewPath}/Required`}
/>
</div>
<div
  data-testid="Content.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<SubPrompt
  viewPath={`${viewPath}/SubPrompt`}
/>
</div>
<div
  data-testid="Content.Horizontal:3"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal3}`}
>
<AdditionalFields
  viewPath={`${viewPath}/AdditionalFields`}
/>
</div>
<DependsOn
  viewPath={`${viewPath}/DependsOn`}
/>
<div
  data-testid="Content.Horizontal:4"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal4}`}
>
<Id
  viewPath={`${viewPath}/Id`}
/>
</div>
</div>
{children}
</React.Fragment>)
}